import React, { ChangeEvent, FC } from 'react';

import { FieldType } from '~src/types';

import InputLabelWrapper, { TextAlign } from './InputLabelWrapper';
import { FormInput } from './inputs.sc';

interface OwnProps {
  autoFocus?: boolean;
  error?: string;
  defaultValue?: string | string[];
  label: string;
  className?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  type?: string;
  value?: string | number;
  setInput?: (ref: HTMLInputElement) => void | null;
  onBlur?: (value: any) => void;
  required?: boolean;
  step?: string;
  min?: number;
  onKeyPress?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  readonly?: boolean;
  textAlign?: TextAlign;
  errorParams?: any;
  placeholder?: string;
  labelKey: string;
}

type Props = OwnProps & Partial<FieldType>;

const CustomFormInput: FC<Props> = (props) => {
  const {
    autoFocus = false,
    value,
    defaultValue,
    readonly,
    textAlign = 'left',
    errorParams,
    error,
    labelKey,
    setInput,
    ...inputProps
  } = props;
  const hasValue = !!defaultValue || !!value || (typeof value !== 'undefined' && value.toString() !== ''); // !!0 gives false
  const { label } = inputProps;

  return (
    <InputLabelWrapper
      insideForm
      valid={!error}
      hasValue={hasValue}
      error={error}
      label={label}
      textAlign={textAlign}
      errorParams={errorParams}
      labelKey={labelKey}
    >
      <FormInput
        autoFocus={autoFocus}
        {...inputProps}
        value={value}
        $valid={!error}
        ref={setInput || undefined}
        disabled={readonly}
      />
    </InputLabelWrapper>
  );
};

export default CustomFormInput;
